/**
 * Account status values
 */
export enum AccountStatusEnum {
	/**
	 * Account account is active and in good standing
	 */
	ACTIVE = 'active',
	/**
	 * Account account is on hold due to other reasons
	 */
	ON_HOLD = 'on_hold',
	/**
	 * Account account is suspended
	 */
	CLOSED = 'closed',
}
